import { Alert, Box, Button, FormControl, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { ILearningPlanActionProps } from "../types/interfaces/ILearningPlanActionProps";
import { IlpData } from "../types/classes/IlpData";
import { useIlpContext } from "../hooks/useIlpContext";
import { useLearnerContext } from "../hooks/useLearnerContext";
import useCreateIlp from "../hooks/useCreateIlp";

//This component is responsible for creating a new learning plan. 
const LearningPlanAction: React.FC<ILearningPlanActionProps> = ({ onCreate }) => {
    const { customerKey, role, isInProcess, setIsInProcess } = useIlpContext();
    const { individualLearningPlans } = useLearnerContext();
    const [newPlanName, setNewPlanName] = useState('');
    const [error, setError] = useState<string | null>(null);

    const DUPLICATE_PLAN_NAME_ERROR = process.env.REACT_APP_ILP_DUPLICATE_PLAN_NAME_ERROR;
    const API_CREATE_ILP = process.env.REACT_APP_API_CREATE_ILP;
    const apiCreateIlp = `${API_CREATE_ILP}${customerKey}`;
    const createIlpFetch = useCreateIlp(apiCreateIlp);

    //Function to handle the new plan name change.
    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPlanName(e.target.value);
        if (error) {
            setError(null);
        }
    };

    //Function to handle an ilp creating.
    const handleCreate = async () => {
        setIsInProcess(true);
        const isDuplicate = individualLearningPlans?.some(plan => plan.LearningPlan?.PlanName === newPlanName);
        if (isDuplicate) {
            setError(`${DUPLICATE_PLAN_NAME_ERROR}`);
            setIsInProcess(false);
            return;
        }

        let ilpData = new IlpData<string>(role, newPlanName);
        const newIlp = await createIlpFetch(ilpData);
        onCreate(newIlp[0]);
        setNewPlanName('');
        setIsInProcess(false);
    };

    //Function to handle the error message closing.
    const handleCloseAlert = () => {
        setError(null);
    };

    return (
        <>
            <Typography variant="h6" color="black" component="div" sx={{mb:2}}>
                <Box sx={{ fontWeight: 'bold' }}>Start and name your ILP</Box>
            </Typography>
            <FormControl sx={{ width: "60%", minWidth: 255 }}>
                <Box mb={2}>
                    <TextField label="ILP Name" size="small" fullWidth value={newPlanName} onChange={handleTextChange} sx={{ mr: 2 }} />
                </Box>
                {error ? (
                    <Alert severity="error" onClose={handleCloseAlert} sx={{ flexGrow: 1, alignItems: 'center '}}>{error}</Alert>
                ) : (
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            onClick={handleCreate}
                            disabled={!newPlanName || isInProcess}
                            sx={{ maxWidth: 100, mb: 2, fontSize: 24 }}>
                            Create
                        </Button>
                )}
            </FormControl>
        </>
    );
}

export default LearningPlanAction;